import React from "react";
const Logout = () => <p>You have been logged out</p>;
export default Logout;
